import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { focusElement } from '../utils/focusManager';

export const useFocusManagement = () => {
  const location = useLocation();
  const previousLocation = useRef(location.pathname);

  useEffect(() => {
    // Only manage focus if the route actually changed
    if (previousLocation.current !== location.pathname) {
      // Focus the main content area after route change
      const mainContent = document.getElementById('main-content');
      if (mainContent) {
        // Small delay to ensure the new content is rendered
        setTimeout(() => {
          focusElement(mainContent);
        }, 100);
      } else {
        // Fallback: focus the first heading on the page
        const firstHeading = document.querySelector('h1, h2, h3, h4, h5, h6');
        if (firstHeading) {
          setTimeout(() => {
            focusElement(firstHeading);
          }, 100);
        }
      }
      
      previousLocation.current = location.pathname;
    }
  }, [location.pathname]);
};

export const useFocusOnMount = (elementRef, shouldFocus = true) => {
  useEffect(() => {
    if (shouldFocus && elementRef.current) {
      focusElement(elementRef.current);
    }
  }, [elementRef, shouldFocus]);
};
